import { FTTHFlowRuleDetailsAction } from '../actions/FTTHFlowRuleDetailsAction'
import { SequenceManagerAction } from '../actions/SequenceManagerAction'


const initState = {
    requestBody: {
        sectionId: "FTTHFlowRuleDetails",
        steps: [
            {
                sequence: "0",
                stepId: "FTTHFlowRule",
                offerContainerId: "",
                fields: [
                    {
                        name: "FTTHFlowRule",
                        value: ""
                    }
                ]
            }
        ]
    }
}

const FTTHFlowRuleDetailsReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var FTTHFlowRuleValue = { ...state.requestBody.steps };

    switch (type) {

        case FTTHFlowRuleDetailsAction.FTTH_FLOW_RULE_DETAILS_SUCCESS:
            FTTHFlowRuleValue[0].offerContainerId = payload.offerContainerId;
            FTTHFlowRuleValue[0].fields[0].value = payload.flowRuleValue;
            return state;

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'FTTHFlowRuleDetails')
            });
            if (section.length > 0) {
                FTTHFlowRuleValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                for (let i = 0; i < FTTHFlowRuleValue[0].fields.length; i++) {
                    const checkoutField = section[0].steps[0].fields.filter((field: any) => { return (field.name === FTTHFlowRuleValue[0].fields[i].name) })[0];
                    FTTHFlowRuleValue[0].fields[i].value = checkoutField ? checkoutField.value : "";
                }
            }
            return state;

        default:
            return state;
    }

}

export default FTTHFlowRuleDetailsReducer;
